import { render, staticRenderFns } from "./WaybillIndex.vue?vue&type=template&id=ff90732a"
import script from "./WaybillIndex.vue?vue&type=script&lang=js"
export * from "./WaybillIndex.vue?vue&type=script&lang=js"
import style0 from "./WaybillIndex.vue?vue&type=style&index=0&id=ff90732a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports